<style scoped>
    .roles__container {
        display: flex;
        justify-content: flex-start;
        margin: 0 0 10px 0;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        padding-left: 25px;
    }

    .roles__div {
        position: absolute;
        margin-top: 13px;
    }

</style>

<template>
    <div class="roles__div">
        <div class="roles__container">
            <div v-if="filterShow['ENCARGADO'] === true">
                <ejs-radiobutton
                    :change="onChangeFilter" 
                    :checked="filter.indexOf('ENCARGADO') !== -1" 
                    id="radio-encargado"
                    value="ENCARGADO" 
                    label='Encargado'
                    name='filter'>
                </ejs-radiobutton>
            </div>
            <div v-if="filterShow['RESPONSABLE'] === true || forceEncargado">
                <ejs-radiobutton 
                    :change="onChangeFilter" 
                    :checked="filter.indexOf('RESPONSABLE') !== -1 || forceEncargado" 
                    value="RESPONSABLE" 
                    label='Responsable Proceso' 
                    name='filter'>
                </ejs-radiobutton>
            </div>
            <div v-if="filterShow['CONSULTA'] === true">
                <ejs-radiobutton 
                    :change="onChangeFilter" 
                    :checked="filter.indexOf('CONSULTA') !== -1" 
                    value="CONSULTA" 
                    label='Consulta' 
                    name='filter'>
                </ejs-radiobutton>
            </div>
            <div v-if="filterShow['TODOS'] === true">
                <ejs-radiobutton 
                    :change="onChangeFilter" 
                    :checked="filter.indexOf('TODOS') !== -1" 
                    value="TODOS" 
                    label='Todos' 
                    name='filter'>
                </ejs-radiobutton>
            </div>
            <div v-if="filterShow['EQUIPO'] === true">
                <ejs-radiobutton
                    :change="onChangeFilter"
                    :checked="filter.indexOf('EQUIPO') !== -1"
                    value="EQUIPO"
                    label='Equipo'
                    name='filter'>
                </ejs-radiobutton>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'filters-roles',
    data() {
        return {
            filter: [],
            filterActive: false,
            forceEncargado: false,
            filterShow: {
                'ECARGADO' : false,
                'RESPONSABLE' : false,
                'CONSULTA' : false,
                'TODOS' : false
            },
            filterActiveName: ''
        }
    },
    methods: {
        initFiltersRoles: function() {
            //Muestra Filtros que se pueden usar para el usuario
            let availablesFilters = JSON.parse(localStorage.getItem('available_filters'));
            availablesFilters.forEach(element => this.filterShow[element] = true);
            if(this.filterShow['ENCARGADO'] || this.filterShow['RESPONSABLE'] || this.filterShow['TODOS']){
                Vue.prototype.$eventHub.$emit('canEditProcess');
            }

            //Habilitar Filtros Guardados
            this.filter = JSON.parse(localStorage.getItem('global_filters'));
            
            this.filterActiveName = this.filter[0];
            if (this.filter != null){
                if(this.filter.length > 0){
                    this.filterActive = true;
                }
            }
            else{
                this.filter = [];
            }
            if(this.filter.includes('ENCARGADO')){
                Vue.prototype.$eventHub.$emit('isTabEncargado', true);
            }else{
                Vue.prototype.$eventHub.$emit('isTabEncargado', false);
            }
            if(this.filter.includes('CONSULTA')){
                Vue.prototype.$eventHub.$emit('isTabConsulta', true);
            }

            if(this.filter.includes('ENCARGADO') || this.filter.includes('RESPONSABLE') || this.filter.includes('TODOS')){
                Vue.prototype.$eventHub.$emit('canEditProcess');
            }
        },
        clearCheckboxFilter: function() {
            this.filter = [];
            localStorage.removeItem('global_filters');
            this.filterActive = false;
            this.$parent.onClickFilterRoles(this.filter);
        },
        onChangeFilter: function(args) {
            this.filter = [];
            var checkboxObj = args.event.target.ej2_instances[0];
            if(checkboxObj.checked) {
                this.filter.push(checkboxObj.value);
            }else{
                const index = this.filter.indexOf(checkboxObj.value);
                if (index > -1) {
                    this.filter.splice(index, 1);
                }
            }
            if(this.filter.length === 0){
                localStorage.removeItem('global_filters');
                this.filterActive = false;
            }
            else
            {
                this.$store.dispatch('moduleSession/updateGlobalFilters', { filter: this.filter });
                this.filterActive = true;
                this.filterActiveName = this.filter[0];
            }
            this.$parent.onClickFilterRoles(this.filter);
            
            if(this.filter.includes('ENCARGADO')){
                Vue.prototype.$eventHub.$emit('isTabEncargado', true);
            }else{
                Vue.prototype.$eventHub.$emit('isTabEncargado', false);
            }
            
            if(this.filter.includes('CONSULTA')){
                Vue.prototype.$eventHub.$emit('isTabConsulta', true);
            }
            
            if(this.filter.includes('ENCARGADO') || this.filter.includes('RESPONSABLE') || this.filter.includes('TODOS')){
                Vue.prototype.$eventHub.$emit('canEditProcess');
            }
        }
    },
    created: function() {
        this.initFiltersRoles();
        this.$eventHub.$on('showEncargadoButton', () => {
          
            this.forceEncargado = true;

        });
    }
}
</script>
